// extracted by mini-css-extract-plugin
module.exports = {"recipientsList":"recipientList_recipientsList__3q3dS commonStyles_typography__2kf2S commonStyles_inputTextColor__3VRpz"};